import React, { useState } from "react";
import ErrorHandler from "../../error-handler/ErrorHandler";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../api/axiosInstance";
import {
    checkDocument,
  getPagenatedDocuments,
} from "../../api/documentCheckRequests";
import Checker from "../layout/form/Checker";

function CheckDocuments() {
  const { t } = useTranslation();

  const [columns, setCoulmns] = useState([
    {
      name: `${t("documentForm.enName")}`,
      selector: (row) => row?.title_en,
      sortable: true,
      right: true,
    },
    
    {
      name: `${t("documentForm.arName")}`,
      selector: (row) => row?.title_ar,
      sortable: true,
      right: true,
    },
  ]);

  return (
    <Checker
      header={t("checkDocuments")}
      columns={columns}
      dataFunction={getPagenatedDocuments}
      checkFunction={checkDocument}
      modelHeader={t("unverifiedTable.msg")}
    ></Checker>
  );
}

export default ErrorHandler(CheckDocuments, axiosInstance);
